import {NgModule} from '@angular/core';
import {AdminReportsService} from './admin-reports.service';

@NgModule({
    providers: [AdminReportsService]
})
export class AdminReportsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/admin-reports/admin-reports.module.ts